import { BasketItemType } from '@domgen/dgx-fe-basket';
import { PaymentTerm } from '@domgen/dgx-fe-common';

export interface CheckoutItemDetails {
  fee: number;
  itemId: string;
  itemType: BasketItemType;
  paymentTerm: PaymentTerm;
  periodOfCover: number;
  quoteId: string;
  tax?: number;
}
